import type { Encounter } from "@medplum/fhirtypes";
import { ENCOUNTER_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Encounter resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useEncounterSubscription = createSubscriptionHook<Encounter>("Encounter", ENCOUNTER_COLLECTION_NAME);
